import { render } from "./WorkFormDeceasedDeath.vue?vue&type=template&id=8b9da8e4"
import script from "./WorkFormDeceasedDeath.vue?vue&type=script&lang=js"
export * from "./WorkFormDeceasedDeath.vue?vue&type=script&lang=js"

import exportComponent from "/Users/francois/WebstormProjects/crema-manager-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__